<template>
  <b-form ref="form" >
    <div class="row">
      <div class="row col-12 pr-0 mb-3">
        <span>Are you sure you want to delete <strong>{{ name }}</strong>?</span>
      </div>
    </div>
  </b-form>
</template>

<script>

export default {
  components: {
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    },
    module: {
      type: String,
      required: true
    }
  },
  computed: {
    id() {
      let parameters = this.parameters || {}
      return parameters.id
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    }
  },
  data () {
    return {
      name: '',
      model: {}
    }
  },
  methods: {
    fetchData() {
      if (!this.id) return;

      return this.$store.dispatch(`${this.module}/find`, { id: this.id })
      .then(result => {
        if (result && result.data) {
          this.model = result.data;
          this.name = result.data.name;
        }
      })
      .catch(err => console.log(err))
    }
  },
  mounted() {
    if (this.id) {
      this.fetchData();
    }
  },
}
</script>